// extracted by mini-css-extract-plugin
export default {"error":"WEYBwlG6BpNlDTLRUD0i"};